import React from 'react';
import ReactDOM from 'react-dom/client';

import './i18n/index';
import './shared/styles/global.css';

import App from './App';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('could not find root element to mount to');
}

const normalizePath = value => value.replace(/\/index\.html$/, '').replace(/\/+$/, '') || '/';
if (window.location.pathname.endsWith('/index.html')) {
  window.history.replaceState(window.history.state, '', normalizePath(window.location.pathname) + window.location.search + window.location.hash);
}
const prerendered = rootElement.dataset.ssgPath === normalizePath(window.location.pathname);
const app = <React.StrictMode><App prerendered={prerendered} /></React.StrictMode>;
if (prerendered) {
  ReactDOM.hydrateRoot(rootElement, app);
} else {
  ReactDOM.createRoot(rootElement).render(app);
}
